import React, { useEffect } from 'react'
import { withFormik, Form, Field } from 'formik'
import { Link } from 'react-router-dom'
import { reactivateAccount } from '../utils/authService';
import { withTranslation } from 'react-i18next';

const validate = (values, props) => {
  let errors = {};

  if (!values.userName) {
    errors.userName = props.t('enterUserName');
  }

  return errors;
};

const ReactivationComponent = (props) => {
  const {
    values,
    handleChange,
    dirty,
    errors,
    t,
    touched,
    isSubmitting,
  } = props

  useEffect(() => {
    document.title = `City of Seattle | Reactivate Account`
  }, [])

  return (
    <div>
      <h2>{t("reactivationTokenHeader")}</h2>
      <p>{t('reactivationEnterForInstructions')}</p>
      <Form className="App-form">

        <div className={"form-group form-group-lg " + (errors.userName && touched.userName ? 'has-error' : '')}>
          <label htmlFor="userName" className="control-label">{t('userName')} <span className="text-danger">*</span></label>
          <Field type="userName" className="form-control" name="userName" value={values.userName} onChange={handleChange} />
          {errors.userName && touched.userName && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            {touched.userName && errors.userName}
          </div>}
        </div>


          <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={!dirty || isSubmitting}>{t('submit')}</button>
      </Form>
      <div className="return-link">
        <Link to='/login'>{t('returnLogin')}</Link>
      </div>

    </div>

  )
}

const Reactivation = withFormik({
  mapPropsToValues({ userName, showNotification, t }) {
    return {
      userName: userName || '',
      showNotification: showNotification,
      t
    }
  },
  validate: validate,
  handleSubmit({ userName }, { props, setSubmitting }) {
    reactivateAccount(userName)
    .then(() => {
      sessionStorage.setItem('activated', true);
      props.showNotification({
        type: 'success',
        title: props.t('reactivationEmailSuccessTitle'),
        message: props.t('reactivationEmailSuccess')
      });
    }).catch(() => {
      props.showNotification({
        type: 'failure',
        title: props.t('reactivationEmailFailedTitle'),
        message: props.t('reactivationEmailFailed'),
      })
    })
    .finally(() => {
      setSubmitting(false);
    });
  }
})(ReactivationComponent)

export default withTranslation()(Reactivation);
